import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const fetchMyPlansDocumentsStarted = () => {
  return {
    type: actionTypes.FETCH_MYPLANS_DOCUMENTS_STARTED,
  };
};

export const fetchMyPlansDocumentsSuccess = (myPlansDocuments) => {
  return {
    type: actionTypes.FETCH_MYPLANS_DOCUMENTS_SUCCESS,
    myPlansDocuments: myPlansDocuments,
  };
};
export const fetchMyPlansDocumentsSuccessNoList = (myPlansMessage) => {
  return {
    type: actionTypes.FETCH_MYPLANS_DOCUMENTS_SUCCESS_NO_LIST,
    myPlansMessage: myPlansMessage,
  };
};
export const fetchMyPlansDocumentsFailed = (errorMessage) => {
  return {
    type: actionTypes.FETCH_MYPLANS_DOCUMENTS_FAILED,
    errorMessage: errorMessage,
  };
};

export const fetchMyPlansDocuments = (
  userId: string,
  pageNumber: number,
  pageSize: number
) => {
  return (dispatch) => {
    dispatch(fetchMyPlansDocumentsStarted());
    axios
      .get(
        serverconfigs.fetchMyPlansDocumentsUrl+`?userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}&lang=` +
          (localStorage.getItem("i18nextLng") === "en" ? "en" : "es")
      )
      .then((response) => {
        console.log(response.data);
        if (response.data.result && response.data.result.length > 0)
          dispatch(fetchMyPlansDocumentsSuccess(response.data.result));
        else
          dispatch(fetchMyPlansDocumentsSuccessNoList(response.data.message));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            dispatch(fetchMyPlansDocumentsFailed(error.response.data.message));
          } else {
            dispatch(fetchMyPlansDocumentsFailed(error.message));
          }
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
          dispatch(fetchMyPlansDocumentsFailed(error.message));
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
          dispatch(fetchMyPlansDocumentsFailed(error.message));
        } else {
          dispatch(fetchMyPlansDocumentsFailed(error.message));
        }
      });
  };
};
